import './style.scss';

export function oms_x_perio_block() {
  const block = document.querySelector('.oms_x_perio_block');
  if (!block) return;
  
}
